import { render, staticRenderFns } from "./ChooseWebshopView.vue?vue&type=template&id=977430de"
import script from "./ChooseWebshopView.vue?vue&type=script&lang=ts"
export * from "./ChooseWebshopView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports